/** @jsxImportSource @emotion/react */
import React from 'react';
import Container from '@mui/material/Container';
import Product from './product';
import tw, { styled } from 'twin.macro';
import useStorageData from '../../hooks/useStorageData';

import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from "react-virtualized";

const cache = new CellMeasurerCache({
  defaultHeight: 200,
  minHeight: 175,
  fixedHeight: false
});

const rowRenderer = ({ index, key, parent, style }) =>{
  return <CellMeasurer
      cache={cache}
      columnIndex={0}
      key={key}
      parent={parent}
      rowIndex={index}
    >
      {({measure, registerChild}) => (<div ref={registerChild} style={style}><Product measure={measure} dataIndex={index}/></div>)}
    </CellMeasurer>
};

const ProductList = () => {
  
  const { productList } = useStorageData();


  return (
  <ListWrapper id="productList">
    {navigator.userAgent !== "ReactSnap" &&
      <div css={tw`-ml-11 h-full`}>
        <AutoSizer onResize={({ height, width }) => {
        }}>
          {({ height, width }) => (
            <List
              height={height}
              width={width}
              deferredMeasurementCache={cache}
              rowHeight={cache.rowHeight}
              rowCount={productList.length}
              rowRenderer={rowRenderer}
            />
          )}
        </AutoSizer>
      </div>
    }
  </ListWrapper>);
};

export default ProductList;


const ListWrapper = styled.div`
  ${tw`
    w-[calc(100vw - 354px - 334px)]
    max-w-[1200px]
    pl-6
    h-[calc(100vh - 130px)]
  `}
`;

